export const  subscriptionConst = {
    GET_SUBSCRIPTION_REQUEST: 'GET_USERS_REQUEST',
    GET_SUBSCRIPTION_SUCCESS: 'GET_USERS_SUCCESS',
    GET_SUBSCRIPTION_FAILURE: 'GET_USERS_FAILURE',

    UPDATE_SUBSCRIPTION_REQUEST: 'UPDATE_USERS_REQUEST',
    UPDATE_SUBSCRIPTION_SUCCESS: 'UPDATE_USERS_SUCCESS',
    UPDATE_SUBSCRIPTION_FAILURE: 'UPDATE_USERS_FAILURE',
}